export default __webpack_public_path__ + "static/media/trucksLine-future.e9fbd3d0.jpg";